import { createUseStyles } from 'react-jss'

import { black, backgroundGrey, mediumGrey } from '../../../styles/const/colors'
import { angleIcon } from '../../../styles/common/components'
import { phonesDown, tabletDown } from '../../../styles/const/breakpoints'

const useStyles = createUseStyles(theme => ({
  // part of range styles are in the index.css
  // that is because of issue of reusing same rule for different selectors in react-jss
  dateRange: {
    width: '100%'
  },
  dateRangeDropdown: {
    display: 'flex',
    flexDirection: 'column'
  },
  calendarIcon: {
    marginLeft: 12,
    color: mediumGrey,
    width: 16
  },
  dateRanges: {
    display: 'flex',
    backgroundColor: 'white'
  },
  staticRangeList: {
    fontSize: 12,
    padding: '18px 0',
    listStyle: 'none'
  },
  staticRangeItem: {
    padding: '5px 15px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: backgroundGrey
    }
  },
  rangeItemActive: {
    backgroundColor: theme.brandPrimaryLight,
    fontWeight: 'bold'
  },
  range: {
    position: 'relative',

    '& .rdrNextPrevButton': {
      width: 13,
      height: 'auto',
      background: 'none',

      '&:before': {
        extend: angleIcon
      },
      '& i': {
        display: 'none'
      }
    },

    '& .rdrDayNumber, & .rdrDayToday .rdrDayNumber span': {
      fontWeight: 400
    },

    '& .rdrNextPrevButton:before': {
      width: [13, '!important']
    },

    '& .rdrPprevButton': {
      transform: 'rotate(90deg)'
    },

    '& .rdrNextButton': {
      transform: 'rotate(-90deg)'
    },

    '& .rdrMonthAndYearPickers': {
      display: 'none'
    },

    '& .rdrMonthName': {
      position: 'absolute',
      top: 0,
      padding: '15px 0',
      fontSize: 16,
      color: black
    },
    '& .rdrMonth': {
      position: 'relative'
    },
    '& .rdrMonth:first-child .rdrMonthName': {
      top: 0,
      left: '50%',
      transform: 'translate(-50%, -100%)'
    },
    '& .rdrMonth:nth-child(2) .rdrMonthName': {
      right: '50%',
      transform: 'translate(50%, -100%)'
    },
    '& .rdrDayToday .rdrDayNumber span:after': {
      background: theme.brandPrimary
    }
  },
  saveBtn: {
    marginLeft: 'auto',
    marginBottom: 15,
    marginRight: 15
  },
  dateRangeMobile: {},

  [`@media screen and (${tabletDown})`]: {
    dateRangeMobile: {
      width: '125px',
      maxWidth: '125px',
      '& [class*="control"]': {
        minHeight: 32,
        maxHeight: 32
      }
    },
    saveBtn: {
      width: '90%',
      margin: '0 auto 16px'
    }
  },

  [`@media screen and (${phonesDown})`]: {
    range: {
      '& .rdrMonth:first-child .rdrMonthName': {
        left: '50%'
      }
    }
  }
}))

export default useStyles
